import { getApiConfig } from '../utils/apiUtils';
import axios from 'axios';

const API_BASE = '/distribution/api/channel-mappings';

export const fetchAllChannelMappings = async (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.channel_id) params.append('channel_id', filters.channel_id);
  if (filters.room_type_id) params.append('room_type_id', filters.room_type_id);
  
  const url = params.toString() ? `${API_BASE}/?${params.toString()}` : `${API_BASE}/`;
  const response = await axios.get(url, getApiConfig());
  return response.data;
};

export const fetchChannelMappingById = async (mappingId) => {
  const response = await axios.get(`${API_BASE}/${mappingId}/`, getApiConfig());
  return response.data;
};

export const createChannelMapping = async (mappingData) => {
  const response = await axios.post(`${API_BASE}/`, mappingData, getApiConfig());
  return response.data;
};

export const updateChannelMapping = async (mappingId, mappingData) => {
  const response = await axios.put(`${API_BASE}/${mappingId}/`, mappingData, getApiConfig());
  return response.data;
};

export const deleteChannelMapping = async (mappingId) => {
  const response = await axios.delete(`${API_BASE}/${mappingId}/`, getApiConfig());
  return response.data;
};

export const deleteChannelMappingsByChannel = async (channelId) => {
  const response = await axios.delete(`${API_BASE}/`, {
    ...getApiConfig(),
    params: { channel_id: channelId },
  });
  return response.data;
};

export const fetchChannelMappingCatalog = async (channelId) => {
  const response = await axios.get('/distribution/api/channel-mapping-catalog/', {
    ...getApiConfig(),
    params: { channel_id: channelId },
  });
  const payload = response.data;
  if (payload?.groups || payload?.room_types || payload?.rate_plans) {
    return payload;
  }
  return payload?.data || payload;
};

export const fetchChannelMappingBoard = async () => {
  const response = await axios.get('/distribution/api/channel-mapping-board/', getApiConfig());
  return response.data;
};

export const fetchChannelMappingRoomPlans = async (roomTypeId) => {
  const response = await axios.get('/distribution/api/channel-mapping-room-plans/', {
    ...getApiConfig(),
    params: { room_type_id: roomTypeId },
  });
  return response.data;
};

export const applyChannelRoomMappings = async (payload) => {
  const response = await axios.post(`${API_BASE}/apply-rooms/`, payload, getApiConfig());
  return response.data;
};

export const setChannelMappingsActive = async (mappingIds, isActive) => {
  const ids = (mappingIds || []).filter((id) => id != null);
  if (!ids.length) {
    return { success: true, updated: 0, mapping_ids: [], is_active: isActive };
  }
  if (ids.length === 1) {
    const response = await axios.patch(
      `${API_BASE}/${ids[0]}/`,
      { is_active: isActive },
      getApiConfig()
    );
    return response.data;
  }
  const response = await axios.patch(
    `${API_BASE}/`,
    { mapping_ids: ids, is_active: isActive },
    getApiConfig()
  );
  return response.data;
};

